import React, { FC } from 'react';

import Overlay from '@sv-support-sdk/ui-components/src/components/Layout/Overlay';

import Modal from '../../../components/Layout/Modal';

import { useAppDispatch } from '../../../store/hooks';
import modalActions from '../../../store/actions/modals';
import { FULL_SIZE_IMAGE_MODAL } from '../../../constants/modals';

import css from './style.module.scss';

interface IProps {
  imageLink: string;
}

const FullSizeImageModal: FC<IProps> = ({ imageLink }) => {
  const dispatch = useAppDispatch();

  const closeModal = () => {
    dispatch(modalActions.closeModal(FULL_SIZE_IMAGE_MODAL));
  };

  const handleOverlayClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      closeModal();
    }
  };

  return (
    <Overlay align="center" zIndex="1501" onClick={handleOverlayClick}>
      <Modal onCloseClick={closeModal} className={css.modal} headerClassName={css.modal__header}>
        <img className={css.modal__img} src={imageLink} alt="" />
      </Modal>
    </Overlay>
  );
};

export default FullSizeImageModal;
